import { animated, useTransition } from '@react-spring/web';
import React, {} from 'react';
import { useIntl } from 'react-intl';
import { useNavigationContextV3 } from '../NavigationContextV3/NavigationContextV3.js';
import { getLogoATagClasses, getLogoCollapsedClasses, getLogoOpenClasses } from './logoV3.logic.js';
export function Logo({ className, collapsedLogo, expandedLogo, logoUrl, onClick }) {
    const { leftNavCollapsed } = useNavigationContextV3();
    const intl = useIntl();
    const fadeInOutTransition = useTransition(!leftNavCollapsed, {
        from: { opacity: 0 },
        enter: { opacity: 1 },
        leave: { opacity: 0 },
        config: { duration: 250 }
    });
    return (React.createElement("a", { "data-testid": "logo", href: logoUrl, onClick: (event) => {
            event.preventDefault();
            onClick?.();
        }, className: getLogoATagClasses(className?.root) },
        React.createElement("img", { src: collapsedLogo, "data-testid": "logo-collapsed", alt: intl.formatMessage({
                defaultMessage: 'Logo Icon',
                id: 'ltEZ52',
                description: 'Alt img text for product logo icon'
            }), className: getLogoCollapsedClasses(className?.collapsedImg) }),
        fadeInOutTransition((style, item) => item && (React.createElement(animated.img, { style: style, "data-testid": "logo-expanded", src: expandedLogo, alt: intl.formatMessage({
                defaultMessage: 'Logo Icon',
                id: 'ltEZ52',
                description: 'Alt img text for product logo icon'
            }), className: getLogoOpenClasses(className?.expandedImg) })))));
}
//# sourceMappingURL=LogoV3.js.map